import {productImageStyles} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { css } from "styled-components";

productImageStyles.productImage = {
    image: {
        width: "auto",
        css: css`
            img {
            }
        `,
    },
    linkWrappingImage: {
        css: css`
            width: 100%;
            justify-content: center;
        `,
    },
}